import type { NotificationHubItem } from "./mapApiNotificationToHubItem.ts";

export function isPendingPostulationSend(item: NotificationHubItem): boolean {
  if (item.type !== "APPLICATION_SENT") return false;
  const perm = item.raw.postulacionPermiso;
  const st = (perm?.status ?? "").toString().trim().toUpperCase();
  if (st !== "SEND" && st !== "SENT") return false;
  const id = perm?.id;
  return id !== undefined && id !== null && Number.isFinite(Number(id));
}

export function getPostulationPermisoId(item: NotificationHubItem): number | null {
  const id = item.raw.postulacionPermiso?.id;
  const n = Number(id);
  return Number.isFinite(n) ? n : null;
}
